import React from "react";
import { inject, observer } from "mobx-react";
import { Icon } from "antd";

import Language from "../../language/language";
import SchoolItem from "./schoolItem";

import "../stylesheets/schoolsForm.scss";

@inject("teamStore", "languageStore")
@observer
class SchoolsForm extends React.Component {
  componentDidMount() {
    this.initForm();
  }

  initForm = () => {
    if (!this.props.teamStore.schoolsInfo) {
      this.handleOnChange([""]);
    } else {
      const lang = this.props.languageStore.lang;
      const schoolNames = this.props.teamStore.schoolsInfo.map(item => {
        return lang === "zh" ? item.name || item.enName : item.enName || item.name;
      });
      this.handleOnChange(schoolNames);
    }
  };

  addSchool = () => this.handleOnChange([...this.props.value, ""]);

  removeSchool = index => {
    const newValue = [...this.props.value];
    newValue.splice(index, 1);
    this.handleOnChange(newValue);
  };

  handleItemOnChange = (idx, value) => {
    const newValue = [...this.props.value];
    newValue.splice(idx, 1, value);
    this.handleOnChange(newValue);
  };

  handleOnChange = value => this.props.onChange && this.props.onChange(value);

  render() {
    // 当前队伍的学校信息
    const { value, teamType, disabled } = this.props;
    if (!value) return null;
    const num = value.length;

    return (
      <div className="schoolsForm">
        {value.map((item, index) => {
          return (
            <SchoolItem
              disabled={disabled}
              key={index + 1}
              idx={index}
              value={item}
              onChange={this.handleItemOnChange}
              canDelete={index > 0}
              onRemove={() => this.removeSchool(index)}
            />
          );
        })}
        {teamType === 1 && !disabled ? (
          <div className="schoolsForm__addSchool">
            {num < 5 ? (
              <div className="schoolsForm__addSchool--btn" onClick={this.addSchool}>
                <Icon type="plus" /> <Language resource="ADD_UNITED_SCHOOL" />
              </div>
            ) : (
              <Language resource="ADD_UNITED_SCHOOL_TIP" />
            )}
          </div>
        ) : null}
      </div>
    );
  }
}

export default SchoolsForm;



// WEBPACK FOOTER //
// ./src/components/createTeam/schoolsForm/index.js